import $ from '@nodemodules/jquery';

// Store modal instances for global access
let mcModalInstances = {};

function mcModalInit() {
  const modalElList = document.querySelectorAll('.mt-modal');
  
  [...modalElList].forEach(modalEl => {
    if (modalEl.id) {
      mcModalInstances[modalEl.id] = $(modalEl).modal('hide');
    }
  });
  // Attach click handlers to trigger buttons
  const triggerButtons = document.querySelectorAll('[data-mt-target]');
  triggerButtons.forEach(button => {
    button.addEventListener('click', () => {
      const targetID = button.getAttribute('data-mt-target').replace('#', '');
      const sourceInputID = button.getAttribute('data-mt-email-source');
      const targetEmailSelector = button.getAttribute('data-mt-email-target');

      // Transfer email if data attributes are present
      if (sourceInputID && targetEmailSelector) {
        transferEmailToModal(sourceInputID, targetEmailSelector);
      }

      showModal(targetID);
    });
  });
}

function showModal(modalID) {
  const modalEl = document.getElementById(modalID);
  if (!modalEl) {
    return;
  }
  if (mcModalInstances[modalID]) {
    mcModalInstances[modalID].modal('show');
  }
}

function transferEmailToModal(sourceInputID, targetEmailFieldSelector) {
  const sourceInput = document.getElementById(sourceInputID);
  const targetEmailField = document.querySelector(targetEmailFieldSelector);
  
  if (sourceInput && targetEmailField) {
    targetEmailField.value = sourceInput.value;
    sourceInput.value = '';
  }
}

function toggleModal(modalID) {
  const modalEl = document.getElementById(modalID);
  if (!modalEl) {
    return;
  }
  if (mcModalInstances[modalID]) {
    mcModalInstances[modalID].modal('toggle');
  }
}

export { mcModalInit, showModal, toggleModal, transferEmailToModal };